<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  enableTracking: boolean;
}>();

const statusLabel = computed(() => {
  if (props.enableTracking) {
    return "Active";
  }

  return "Not active";
});

const statusColor = computed(() => {
  if (props.enableTracking) {
    return "green-lighten-2";
  }

  return "red-lighten-2";
});
</script>

<template>
  <v-chip :color="statusColor" class="font-size-11 text-white" size="x-small" variant="flat">{{ statusLabel }}</v-chip>
</template>

<style lang="scss" scoped>
.status {
  border-radius: 7px;
}
</style>
